import IconMessengerEmail from '@/assets/images/icons/messengers/email-color.svg';
import IconMessengerViber from '@/assets/images/icons/messengers/viber-color.svg';
import IconMessengerWhatsApp from '@/assets/images/icons/messengers/whatsapp-color.svg';
import IconMessengerTelegram from '@/assets/images/icons/messengers/telegram-color.svg';
import IconMessengerYandex from '@/assets/images/icons/messengers/yandex-color.svg';
import IconMessengerMax from '@/assets/images/icons/messengers/max-color.svg';
import IconMessengerBitrix from '@/assets/images/icons/messengers/bitrix-color.svg';
import IconMessengerP7 from '@/assets/images/icons/messengers/P7-color.svg';
import IconMessengerAitu from '@/assets/images/icons/messengers/aitu-color.svg';

export const MESSENGERS = {
  EMAIL: 'E-mail',
  VIBER: 'Viber',
  WHATS_APP: 'WhatsApp',
  TELEGRAM: 'Telegram',
  YANDEX: 'Yandex',
  MAX: 'Max',
  BITRIX: 'Bitrix',
  P7: 'P7',
  AITU: 'Aitu',
};

export const MESSENGER_ICONS = {
  [MESSENGERS.EMAIL]: IconMessengerEmail,
  [MESSENGERS.VIBER]: IconMessengerViber,
  [MESSENGERS.WHATS_APP]: IconMessengerWhatsApp,
  [MESSENGERS.TELEGRAM]: IconMessengerTelegram,
  [MESSENGERS.YANDEX]: IconMessengerYandex,
  [MESSENGERS.MAX]: IconMessengerMax,
  [MESSENGERS.BITRIX]: IconMessengerBitrix,
  [MESSENGERS.P7]: IconMessengerP7,
  [MESSENGERS.AITU]: IconMessengerAitu,
};

export const getMessengerIcon = (name) => MESSENGER_ICONS[name];

export const MESSENGER_ICONS_BY_ID = {
  0: IconMessengerAitu,
  1: IconMessengerViber,
  2: IconMessengerWhatsApp,
  3: IconMessengerTelegram,
  4: IconMessengerYandex,
  5: IconMessengerMax,
  6: IconMessengerBitrix,
  7: IconMessengerP7,
  8: IconMessengerAitu,
};

export const getMessengerIconById = (id) => MESSENGER_ICONS_BY_ID[id];

export const MESSENGER_LABEL_BY_ID = {
  0: MESSENGERS.AITU,
  1: MESSENGERS.VIBER,
  2: MESSENGERS.WHATS_APP,
  3: MESSENGERS.TELEGRAM,
  4: MESSENGERS.YANDEX,
  5: MESSENGERS.MAX,
  6: MESSENGERS.BITRIX,
  7: MESSENGERS.P7,
  8: MESSENGERS.AITU,
};

export const getMessengerLabelById = (id) => MESSENGER_LABEL_BY_ID[id];
